<ng-container *ngIf="isIndividualSuggestion">
  <app-individual-suggestion-item [parentId]="parentId"
                                  [suggestion]="suggestion"
                                  [itemProduct]="itemProduct"></app-individual-suggestion-item>
</ng-container>